import { Controller } from "@hotwired/stimulus"
import { nativeRequestPush } from "../utils/native_bridge"

// Post-sign-in APNs enrollment nudge for the native iOS app — the turbo-native
// counterpart of push_prompt_controller (which handles Web Push and bows out
// inside the app). Reveals the card only when the server has no apns
// subscription for this user and the nudge wasn't recently dismissed. Enable
// asks the native shell to request permission; on success the shell posts the
// device token to /push_subscription and fires native:push-registered.
const DISMISS_KEY = "jane.native_push_prompt.dismissed_at"
const DISMISS_DAYS = 30

export default class extends Controller {
    static targets = ["card"]
    static values = { subscribed: Boolean }

    connect() {
        if (!document.body.classList.contains("turbo-native")) return
        this._onRegistered = () => this._hide()
        window.addEventListener("native:push-registered", this._onRegistered)
        if (this.subscribedValue) return
        if (this._recentlyDismissed()) return
        if (this.hasCardTarget) this.cardTarget.hidden = false
    }

    disconnect() {
        if (this._onRegistered) window.removeEventListener("native:push-registered", this._onRegistered)
    }

    enable() {
        // Snooze up front so a declined iOS permission dialog can't re-ask on
        // every page load.
        this._snooze()
        nativeRequestPush()
        this._hide()
    }

    dismiss() {
        this._snooze()
        this._hide()
    }

    _hide() {
        if (this.hasCardTarget) this.cardTarget.hidden = true
    }

    _snooze() {
        try {
            localStorage.setItem(DISMISS_KEY, String(Date.now()))
        } catch (e) {}
    }

    _recentlyDismissed() {
        try {
            const at = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10)
            return at && Date.now() - at < DISMISS_DAYS * 24 * 60 * 60 * 1000
        } catch (e) {
            return false
        }
    }
}
